import axios from "axios";

const dev = process.env.NODE_ENV !== 'production';

let globalConfig = window.EPPConfig || {};
let eppInstanceConfig = {
  base_url: globalConfig.base_url || (dev ? 'http://localhost:81' : window.location.origin)
};

if (eppInstanceConfig.base_url === "") {
  alert("Missing or empty EPP API Server URL configuration(window.EPPConfig.base_url)");
}

let sessionToken = null;
let sessionHeader = null;
let globalNoker = null;
let preFlight = null;
let postFlight = null;

function invokePreFlight() {
  if (typeof preFlight === "function") {
    preFlight()
  }
}

function invokePostFlight() {
  if (typeof postFlight === "function") {
    postFlight()
  }
}

const client = axios.create({
  baseURL: eppInstanceConfig.base_url,
  timeout: 1000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

function oker(data, handler) {
  invokePostFlight();
  if (typeof handler !== "function") {
    handler = console.log;
  }
  handler(data);
}

function noker(error, handler) {
  invokePostFlight();
  handler = handler || globalNoker;

  if (typeof handler !== "function") {
    handler = console.log;
  }

  let info = {
    code: 0,
    httpMessage: "",
    message: "",
  };

  if (error.response) {

    if (error.response.status) {
      info.code = error.response.status;
    }

    if (error.response.statusText) {
      info.httpMessage = error.response.statusText;
    }

    if (error.response.data && error.response.data.message) {
        info.message = error.response.data.message;
    }

  } else if (error.request) {
    info.message = 'Server is not responding or the request could not be performed on the endpoint.';
  } else {
    info.message = 'Failed to send request. Malformed configuration? See console for more information.';
    console.error(error);
  }

  handler(info);
}

function authRequest(sessionHeader, sessionToken) {
  let headers = {};
  headers[sessionHeader] = sessionToken;
  return {headers: headers}
}

export default {

  setSession(header, token) {
    sessionToken = token;
    sessionHeader = header;
  },

  setGlobalNoker(fn) {
    globalNoker = fn;
  },

  setPreFlight(fn) {
    preFlight = fn;
  },

  setPostFlight(fn) {
    postFlight = fn;
  },

  // request {
  //    name: string, required
  //    password: string, required
  // }
  logIn(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/user:login', req)
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   current_password: string, required
  //   new_password: string, required
  // }
  changePassword(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:user', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   login_token: string, required
  // }
  reloadSession(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/user:session', req)
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  // }
  listUsers(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:user', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  // }
  listRegistrars(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:registrar', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  //   filter: {
  //     	contact_id: string
  // 	    status: []string
  //      org: string
  // 	    name: string
  // 	    country: string
  // 	    vat: string
  // 	    idnum: string
  //   }, optional
  //   sort_by: string, optional
  // }
  listContacts(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:contact', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  //   filter: {
  //     domain: string
  //     status: []string
  //     admin: string
  //     tech: string
  //     billing: string
  //     registrant: string
  //   }
  // }
  listDomains(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:domain', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  // }
  listAlphaTLD(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:alpha', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  // }
  listLogs(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:log', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  // }
  listTLDs(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:tld', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  // }
  listTransfers(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:transfer', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  // }
  listRGPs(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:rgp', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  // }
  listHosts(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:host', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  // }
  listMessages(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:message', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  // }
  listPendingRequests(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:pending', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },


  // request {
  //   registrar: uint, required
  //   name: string, required
  //   password: string, required
  //   admin: bool
  // }
  createUser(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/user:create', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   user_id: uint, required
  //   name: string, optional
  //   password: string, optional
  //   admin: bool
  // }
  updateUser(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/user:update', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },
  
  // request {
  //   org: string, required
  //   name: string, required
  //   street: string, required
  //   city: string, required
  //   state: string, required
  //   country: string, required
  //   email: string, required
  //   phone: string, required
  //   fax: string
  //   credit: uint, required
  // }
  createRegistrar(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/registrar:create', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   contact_id: string, required
  //   org: string, required
  //   name: string, required
  //   street: string, required
  //   city: string, required
  //   state: string, required
  //   postcode: string, required
  //   country: string, required
  //   email: string, required
  //   telephone: string, required
  //   fax: string, required
  //   authinfo: string, required
  //   disclose_name: bool
  //   disclose_org: bool
  //   disclose_addr: bool
  //   disclose_voice: bool
  //   disclose_fax: bool
  //   disclose_email: bool
  //   idnum: string
  //   vat: string
  //   birthdate: string
  // }
  createContact(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/contact:create', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   domain: string, required
  //   period: uint, required
  //   nameservers: []string
  //   registrant: string, required
  //   contact_admin: string, required
  //   contact_tech: string, required
  //   contact_billing: string, required
  //   authinfo: string
  //   dnskeys: []{
  //      flags: uint, required
  //      protocol: uint, required
  //      alg: uint, required
  //      pubKey: string, required
  //   } optional
  // }
  createDomain(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/domain:create', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   tld: string, required
  // }
  createAlpha(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/alpha:create', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request = {
  //   tld: string, required
  //   price: uint, required
  //   domain_length_min: uint, required
  //   domain_length_max: uint, required
  //   period: []uint, required
  //   period_transfer: uint, required,
  //   idn_allowed: bool
  //   registrant_cc: string
  //   idnum_required: bool
  //   vat_required: bool
  //   birthdate_required: bool
  //   confirmation: bool
  //   auto_renew_period: uint, required
  //   rgp_period: uint, required
  //   pending_delete_period: uint, required,
  //   expiration_policy: string, required
  //   ns_required: bool
  //   plain_transfer: bool
  // }
  createTLD(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/tld:create', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //     name: string, required
  //     ips: []string, required
  // }
  createHost(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/host:create', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //     user_id: uint, required
  // }
  viewUser(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/user:view', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //     registrar_id: uint, required
  // }
  viewRegistrar(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/registrar:view', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //     contact_id: uint, required
  // }
  viewContact(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/contact:view', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //     domain: string, required
  // }
  viewDomain(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/domain:view', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //  domain: string|int, required
  // 	auth_info: string
  // 	registrant: string
  // 	status_add: []string
  // 	status_remove: []string
  // 	admin_contact: string
  // 	tech_contact: string
  // 	billing_contact: string
  // 	ns_add: string[]
  // 	ns_remove: []string
  // 	dnskey_add: []{
  //    flags: uint, required
  //    protocol: uint, required
  //    alg: uint, required
  //    pubKey: string, required
  //  }
  // 	dnskey_remove: []{
  //    flags: uint, required
  //    protocol: uint, required
  //    alg: uint, required
  //    pubKey: string, required
  //  }
  // 	restore_rgp: string
  // }
  updateDomain(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/domain:update', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   id: uint required
  //   name: string
  //   org: string
  //   street: string
  //   postcode: string
  //   city: string
  //   country: string
  //   state: string
  //   email: string
  //   telephone: string
  //   fax: string
  //   authinfo: string
  //   idnum: string
  //   vat: string
  //   birthdate: string
  //   disclose_name: bool
  //   disclose_org: bool
  //   disclose_addr: bool
  //   disclose_voice: bool
  //   disclose_fax: bool
  //   disclose_email: bool
  //   status_add: []string
  //   status_remove: []string
  // }
  updateContact(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/contact:update', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //     tld: string, required
  // }
  viewTLD(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/tld:view', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   domain: string, required
  //   period: uint, required
  //   secret: string, required
  // }
  createTransfer(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/transfer:create', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   request_id: string, required
  //   secret: string, required
  // }
  approveTransfer(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/transfer:approve', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   request_id: string, required
  //   secret: string, required
  // }
  rejectTransfer(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/transfer:reject', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   request_id: string, required
  //   secret: string, required
  // }
  cancelTransfer(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/transfer:cancel', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   page: uint
  //   limit: uint
  // }
  listCreditTransactions(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/collection:transaction', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   registrar: uint, required
  //   credit: int, required
  //   operation: string, required
  //   subject: string, required
  //   note: string
  // }
  createCreditTransaction(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/transaction:create', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   domain: string/uint, required
  // }
  viewDomainRGP(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/domain:rgp', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request {
  //   registrar_id: uint, required
  //   org: string
  //   name: string
  //   street: string
  //   city: string
  //   state: string
  //   country: string
  //   phone: string
  //   fax: string
  // }
  updateRegistrar(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/registrar:update', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request = {
  //   tld: string, required
  //   price: uint, required
  //   domain_length_min: uint, required
  //   domain_length_max: uint, required
  //   period: []uint, required
  //   period_transfer: uint, required,
  //   idn_allowed: bool
  //   registrant_cc: string
  //   idnum_required: bool
  //   vat_required: bool
  //   birthdate_required: bool
  //   confirmation: bool
  //   auto_renew_period: uint, required
  //   rgp_period: uint, required
  //   pending_delete_period: uint, required,
  //   expiration_policy: string, required
  //   ns_required: bool
  //   plain_transfer: bool
  // }
  updateTLD(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/tld:update', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request = {
  //   host_name: string, required
  // }
  viewHost(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/host:view', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request = {
  //   host_name: string, required
  //   ip_add: []string
  //   ip_remove: []string
  //   status_add: []string
  //   status_remove: []string
  // }
  updateHost(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/host:update', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request = {
  //   host_name: string, required
  // }
  deleteHost(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/host:delete', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request = {
  //   contact_id: uint, required
  // }
  deleteContact(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/contact:delete', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request = {
  //   domain: string, required
  // }
  deleteDomain(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/domain:delete', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request = {
  //   user_id: uint, required
  // }
  deleteUser(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/user:delete', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

  // request = {
  //   contact: string, required
  // }
  lookupContact(req, ok, nok) {
    invokePreFlight();
    client
      .post('/api/contact:lookup', req, authRequest(sessionHeader, sessionToken))
      .then((response) => { oker(response.data, ok) }, (error) => { noker(error, nok) })
      .catch((error) => noker(error, nok))
  },

}



// WEBPACK FOOTER //
// ./src/api/index.js